export var tableCell = function tableCell(attrs) {
  return function () {
    for (var _len = arguments.length, content = new Array(_len), _key = 0; _key < _len; _key++) {
      content[_key] = arguments[_key];
    }
    return {
      type: 'tableCell',
      attrs: attrs,
      content: content
    };
  };
};